import React, { useEffect, useState } from "react";
import Sidebar from "../../components/Sidebar/Sidebar";
import { Grid } from "@material-ui/core";
import { Input, Modal, SVG } from "sunrise-ui";
import { AppDispatch } from "../../redux/store";
import { useDispatch, useSelector } from "react-redux";
import {
  deleteMasterData,
  editMasterData,
  getAllMasterType,
  postAddMasterData,
  getMasterData,
} from "../../redux/reducers";
import "./MasterConfig.scss";
import toaster from "../../utilities/toaster";
import Loader from "../../utilities/Loader";
import PopOver from "../../components/PopOver/PopOver";

const MasterConfig = () => {
  const dispatch = useDispatch<AppDispatch>();
  // -----------loader state------------
  let [loading, setLoading] = React.useState(false);
  // ------------------------------

  const [open, setOpen] = useState(false);
  const [modalTitle, setModalTitle] = useState("");
  // const [imageText, setImageText] = useState("");
  const [deleteId, setDeleteId] = useState("");
  const [deleteTitle, setDeleteTitle] = useState("");
  const [showImage, setShowImage] = useState(false);
  const [array, setArray] = useState<any>([]);
  // const [finalArr, setFinalArr] = useState<any>([]);
  const [anchorEl, setAnchorEl] = React.useState(false);
  const [anchorElEdit, setAnchorElEdit] = React.useState(false);
  const [showSubmitButton, setShowSubmitButton] = React.useState(false);
  const [editValue, setEditValue] = React.useState("");
  const [editLabel, setEditLabel] = React.useState("");
  const [edit, setEdit] = React.useState(false);
  const [addType, setAddType] = React.useState<any>("");
  const [addMasterType, setAddMasterType] = React.useState("");
  const [add, setAdd] = React.useState(false);
  const [deleting, setDeleting] = React.useState(false);
  const [editId, setEditId] = React.useState("");
  const [editTitle, setEditTitle] = React.useState("");
  const [deleteType, setDeleteType] = React.useState("");
  const [editTitleUpdate, setEditTitleUpdate] = React.useState<any>("");
  const [searchTerm, setSearchTerm] = useState("");
  const [editType, setEditType] = useState("");
  const [finalArr, setFinalArr] = useState<any>([]);
  const [masterDataArray, setMasterDataArray] = useState<any>([]);
  const [machineArray, setMachineArray] = useState<any>([]);
  const [showXIcom, setShowXIcom] = useState<any>(false);
  const [newLoaded, setNewLoaded] = useState<any>({
    add: false,
    del: false,
    edit: false,
  });
  const [header, setHeader] = useState("");
  const [allMachineParts, setAllMachineParts] = useState([]);
  const [machineParts, setMachineParts] = useState([]);

  let masterTypes = useSelector((state: any) => state.UI.masterData);
  let allMasterTypes = useSelector((state: any) => state.UI.allMasterType);
  let editMasterDatas = useSelector((state: any) => state.UI.editMasterData);
  let addMasterDatas = useSelector((state: any) => state.UI.addMasterData);
  let deleteMasterDatas = useSelector(
    (state: any) => state.UI.deleteMasterData
  );

  //getting all the master data types
  useEffect(() => {
    setFinalArr([]);
    setMasterDataArray([]);
    setArray([]);
    setLoading(true);
    dispatch(
      getMasterData({
        endPoint: "master-data/get-all-master-data-types",
      })
    ).then((res: any) => {
      setLoading(false);
    });
    // eslint-disable-next-line
  }, []);

  //pushin the array of types into a state
  useEffect(() => {
    if (masterTypes?.status === 1) {
      if (array.length === 0) {
        setArray(masterTypes.data);
      }
    }

    // eslint-disable-next-line
  }, [masterTypes]);

  //calling all the types in forEach loop
  useEffect(() => {
    if (array.length > 0) {
      array.forEach((val: any) => {
        dispatch(
          getAllMasterType({
            endPoint: `master-data/get-all-master-types?type=${val}`,
          })
        );
      });
    }
    // eslint-disable-next-line
  }, [array]);

  //push the resopnes of all items in types
  useEffect(() => {
    if (allMasterTypes?.data !== undefined) {
      // checking if add/edit/delete is initiated or not
      if (addType.length > 0 || deleteId.length > 0 || editId.length > 0) {
        const updateState = masterDataArray.map((data: any) => {
          if (data[0]?.type === addMasterType) {
            return allMasterTypes.data;
          }
          if (data[0]?.type === editLabel) {
            return allMasterTypes.data;
          }
          if (data[0]?.type === deleteType) {
            return allMasterTypes.data;
          }
          return data;
        });
        setMasterDataArray(updateState);
        //resetting to initial values
        setAddType("");
        setDeleteId("");
        setEditId("");
      } else {
        if (allMasterTypes?.data[0]?.type.toLowerCase() === "machine") {
          let arr: any = [];
          allMasterTypes.data.forEach((val: any) => {
            arr.push(val.title);
          });
          setMachineArray(arr);
        }
        if (allMasterTypes?.data[0]?.type === "machine-part") {
          setAllMachineParts(allMasterTypes.data);
        }
        setFinalArr((oldArr: any) => [...oldArr, allMasterTypes.data]);
      }
    }
    // eslint-disable-next-line
  }, [allMasterTypes]);

  //checking for duplicate array in some cases
  useEffect(() => {
    let arr: any = [];
    if (array.length < finalArr.length) {
      finalArr.forEach((val: any, i = 1) => {
        if (i > 0) {
          arr.push(val);
        }
      });
      // arr.sort((a: any, b: any) => a[0].type.localeCompare(b[0].type));
      setMasterDataArray(arr);
    } else {
      setMasterDataArray(finalArr);
    }
    // eslint-disable-next-line
  }, [finalArr]);

  //response after successfull editing
  useEffect(() => {
    setNewLoaded((pre: any) => ({ ...pre, edit: true }));
    if (editMasterDatas.status === 1 && newLoaded.edit) {
      setShowSubmitButton(false);
      setAnchorEl(true);
      setOpen(false);
      toaster("success", `${Capitalize(editTitle)} Edited Successfully`);
      // setLoading(true);
      dispatch(
        getAllMasterType({
          endPoint: `master-data/get-all-master-types?type=${editLabel}`,
        })
      ).then(() => {
        setLoading(false);
      });
    }
    // eslint-disable-next-line
  }, [editMasterDatas]);

  //response after successfull adding
  useEffect(() => {
    setNewLoaded((pre: any) => ({ ...pre, add: true }));
    if (addMasterDatas.status === 1 && newLoaded.add) {
      setShowSubmitButton(false);
      setAnchorElEdit(true);
      setOpen(false);
      toaster("success", `${Capitalize(addType)} Added Successfully`);
      // setLoading(true);
      dispatch(
        getAllMasterType({
          endPoint: `master-data/get-all-master-types?type=${addMasterType}`,
        })
      ).then(() => {
        setLoading(false);
      });
    }
    // eslint-disable-next-line
  }, [addMasterDatas]);

  //response after successfull deleting
  useEffect(() => {
    setNewLoaded((pre: any) => ({ ...pre, del: true }));
    if (deleteMasterDatas.status === 1 && newLoaded.del) {
      setAnchorEl(true);
      setOpen(false);
      toaster("success", `${Capitalize(deleteTitle)} Deleted Successfully`);
      // setLoading(true);
      dispatch(
        getAllMasterType({
          endPoint: `master-data/get-all-master-types?type=${deleteType}`,
        })
      ).then(() => {
        setLoading(false);
        setShowSubmitButton(false);
      });
    }
    // eslint-disable-next-line
  }, [deleteMasterDatas]);

  const handleChange = () => {
    setOpen(true);
  };

  //delete method for modal show
  const deleteItem = (id: any, title: any, type: any) => {
    setDeleteId(id);
    setDeleteType(type);
    setDeleteTitle(title);
    setShowImage(false);
    setEdit(false);
    setAdd(false);
    setDeleting(true);
    setOpen(true);
    setModalTitle(
      `Are you sure you want to remove ${Capitalize(title)} from ${Capitalize(
        type
      )} Type ?`
    );
  };

  //show cross icon on search bar after user types
  useEffect(() => {
    if (searchTerm.length > 0) {
      setShowXIcom(true);
    } else {
      setShowXIcom(false);
    }
  }, [searchTerm]);

  const clearInput = () => {
    setSearchTerm("");
  };

  //edit method for modal show
  const editItem = (data: any) => {
    if (editLabel === "items") {
      if (data.length > 15) {
        toaster("error", "Item name cannot be more than 15 characters.");
        return;
      }
    }
    if (data.length > 40) {
      toaster("error", "Title must have maximum 40 characters.");
    } else {
      setEditTitleUpdate(data);
      setOpen(true);
      setShowImage(false);
      setModalTitle(
        `Are you sure you want to edit ${Capitalize(
          editTitle
        )} from ${Capitalize(editLabel)} Type?`
      );
    }
  };

  const send = () => {
    //calling edit api
    setShowSubmitButton(true);
    let obj = {};
    if (edit) {
      if (editLabel === "hmr-reading") {
        obj = {
          id: editId,
          title: editTitleUpdate?.machineType,
          type: editLabel,
          machinePart: editTitleUpdate?.machinePart,
          hmrReading: Number(editTitleUpdate?.hmrReading),
        };
      } else if (editLabel === "machine-part") {
        obj = {
          id: editId,
          title: editTitleUpdate?.machineType,
          type: editLabel,
          machinePart: editTitleUpdate?.machinePart,
        };
      } else {
        obj = {
          id: editId,
          title: editTitleUpdate,
          type: editLabel,
        };
      }
      dispatch(
        editMasterData({
          endPoint: `master-data/edit-master-data`,
          data: obj,
        })
      );
    } else if (deleting) {
      //calling delete api
      if (deleteId.length > 0) {
        dispatch(
          deleteMasterData({
            endPoint: `master-data/delete-master-data/${deleteId}`,
          })
        );
      }
    } else if (add) {
      //calling add api
      if (addMasterType === "machine-part") {
        let obj = {
          title: addType.machineType,
          type: addMasterType,
          machinePart: addType.machinePart,
        };
        dispatch(
          postAddMasterData({
            endPoint: `master-data/create-master-data`,
            data: obj,
          })
        );
      } else if (addMasterType === "hmr-reading") {
        let obj = {
          title: addType.machineType,
          type: addMasterType,
          machinePart: addType.machinePart,
          hmrReading: addType.hmrReading,
        };
        dispatch(
          postAddMasterData({
            endPoint: `master-data/create-master-data`,
            data: obj,
          })
        );
      } else {
        if (addType.length > 0) {
          let obj = {
            title: addType,
            type: addMasterType,
          };
          dispatch(
            postAddMasterData({
              endPoint: `master-data/create-master-data`,
              data: obj,
            })
          );
        }
      }
    }
  };

  //method to capitalize the word
  const Capitalize = (str: any) => {
    if (typeof str === "object") {
      return str.machineType.charAt(0).toUpperCase() + str.machineType.slice(1);
    } else {
      return str.charAt(0).toUpperCase() + str.slice(1);
    }
  };
  const reset = () => {
    setOpen(false);
    setShowImage(false);
    setAnchorEl(false);
    setAnchorElEdit(false);
    setLoading(false);
    setShowSubmitButton(false);
  };
  const [selectedMachinePart, setSelectedMachinePart] = useState("");
  const [selectedHmrReading, setSelectedHmrReading] = useState("");
  //edit popover data
  const handleClick = (id: any, title: any, type: any, item: any) => {
    if (type === "machine-part") {
      setEditValue(item.title);
    }
    setSelectedMachinePart(item.machinePart);
    let arr: any = [];
    allMachineParts.forEach((val: any) => {
      if (val.title === item.title) {
        arr.push(val.machinePart);
      }
    });
    setMachineParts(arr);

    if (item?.hmrReading) {
      setSelectedHmrReading(item.hmrReading);
    }
    setEditId(id);
    setEditTitle(title);
    setEditValue(title);
    setEditLabel(type);
    setEdit(true);
    setDeleting(false);
    setAdd(false);
    if (type === "hmr-reading") {
      setEditType("Add New Hmr-reading Type");
    } else if (type === "machine-part") {
      setEditType("Add New Machine-part Type");
    } else {
      setEditType("");
    }
  };

  //open popOver to add data
  const addNewItem = (type: any, masterType: any) => {
    setShowSubmitButton(false);
    if (masterType === "items") {
      if (type.length > 15) {
        toaster("error", "Item name cannot be more than 15 characters.");
        return;
      }
    }
    if (type.length > 40) {
      toaster("error", "Title must have maximum 40 characters.");
    } else {
      setAddType(type);
      setAddMasterType(masterType);
      setOpen(true);
      setModalTitle(
        `Are you sure you want to add ${Capitalize(type)} to ${Capitalize(
          masterType
        )} Type?`
      );
      setShowImage(false);
      setAdd(true);
      setDeleting(false);
      setEdit(false);
    }
  };

  const headerText = (type: any) => {
    setHeader(type);
  };

  const selectedMachine = (item: any) => {
    let arr: any = [];
    allMachineParts.forEach((val: any) => {
      if (val.title === item) {
        arr.push(val.machinePart);
      }
    });
    setMachineParts(arr);
  };

  return (
    <Sidebar>
      {loading ? (
        <Loader color="#5f67e0" loading={loading} size={20} height="80vh" />
      ) : (
        <div className="w container">
          <Grid className="d-flex jc-sb p1">
            <div className="fw600 f16 d-flex v-center h-center pl0-5">
              Master Config Data
            </div>
            <Grid className="d-flex sb v-center relative">
              <div className="pointer icon">
                {showXIcom ? (
                  <div onClick={() => clearInput()}>
                    <SVG type="closeSearchApiIcon" />
                  </div>
                ) : (
                  <SVG type="searchApiIcon" />
                )}
              </div>
              <Input
                type="text"
                id="tableSearch"
                name="tableSearch"
                placeholder="Search..."
                value={searchTerm}
                onChange={(e: any) => setSearchTerm(e.target.value)}
              />{" "}
            </Grid>
          </Grid>
          <div className="d-flex cont-card">
            {masterDataArray?.length > 0 &&
              masterDataArray.map((item: any, i: any) => {
                return (
                  <div className="sep-card" key={i}>
                    {item && (
                      <div>
                        <div className="p1 d-flex sticky">
                          <div className="w-80 textT-cap fw600 f16">
                            {/* eslint-disable-next-line */}
                            {/* {item[0].type + " " + "Type"} */}
                            {item[0]?.type}
                          </div>
                          <PopOver
                            anchor={anchorEl}
                            button={false}
                            type={
                              "Add New" +
                              " " +
                              Capitalize(header) +
                              " " +
                              "Type"
                            }
                            value={""}
                            // eslint-disable-next-line
                            // label={Capitalize(item[0].type) + " " + "Type"}
                            label={Capitalize(item[0].type)}
                            sendValue={(e: any) => addNewItem(e, item[0].type)}
                            inputUpdate={(e: any) => {}}
                            setHeader={() => headerText(item[0].type)}
                            machineArray={machineArray}
                            selectedMachine={(e: any) => selectedMachine(e)}
                            machineParts={machineParts}
                          ></PopOver>
                        </div>
                        {item
                          // eslint-disable-next-line
                          .filter((val: any) => {
                            if (searchTerm === "") {
                              return val;
                            } else if (
                              val.title
                                .toLowerCase()
                                .includes(searchTerm.toLowerCase())
                            ) {
                              return val;
                            }
                          })
                          .map((item2: any, j: any) => {
                            return (
                              <div className="p1 flex sb" key={j}>
                                <div className="textT-cap f14 fw400">
                                  {item2.type === "hmr-reading" ? (
                                    <div>
                                      {item2.title} : {item2.machinePart}
                                    </div>
                                  ) : item2.type === "machine-part" ? (
                                    <div>
                                      {item2.title} : {item2.machinePart}
                                    </div>
                                  ) : (
                                    <div>{item2.title}</div>
                                  )}
                                </div>
                                <div className="sb v-center d-flex w-25">
                                  <div
                                    onClick={(e: any) => {
                                      handleClick(
                                        item2._id,
                                        item2.title,
                                        item2.type,
                                        item2
                                      );
                                      // setEditValue(item2.title);
                                      setAnchorElEdit(true);
                                    }}
                                    className="pointer"
                                  >
                                    <PopOver
                                      anchor={anchorElEdit}
                                      button={true}
                                      value={editValue}
                                      type={
                                        "Edit" +
                                        " " +
                                        Capitalize(item2.title) +
                                        " "
                                      }
                                      label={
                                        // eslint-disable-next-line
                                        // Capitalize(editLabel) + " " + "Type"
                                        Capitalize(editLabel)
                                      }
                                      editType={editType}
                                      sendValue={(e: any) => editItem(e)}
                                      inputUpdate={(e: any) => {}}
                                      setHeader={() => headerText(item[0].type)}
                                      machineArray={machineArray}
                                      selectedMachine={(e: any) =>
                                        selectedMachine(e)
                                      }
                                      machineParts={machineParts}
                                      selectedMachinePart={selectedMachinePart}
                                      selectedHmrReading={selectedHmrReading}
                                    ></PopOver>
                                  </div>

                                  <div
                                    onClick={() =>
                                      deleteItem(
                                        item2._id,
                                        item2.title,
                                        item2.type
                                      )
                                    }
                                    className="pointer"
                                  >
                                    <span
                                      className="iconify"
                                      data-icon="fluent:delete-20-regular"
                                      data-width="20"
                                      data-height="20"
                                      style={{ color: "#961B01" }}
                                    ></span>
                                  </div>
                                </div>
                              </div>
                            );
                          })}
                      </div>
                    )}
                  </div>
                );
              })}
            <Modal
              title={modalTitle}
              showImageModal={showImage}
              image={"inventoryModal"}
              // imageText={imageText}
              modalBtnText="Submit"
              onClick={() => handleChange()}
              openModal={open}
              call={() => send()}
              reset={() => reset()}
              showLoaderIcon={showSubmitButton}
            ></Modal>
          </div>
        </div>
      )}
    </Sidebar>
  );
};

export default MasterConfig;
